<div *ngIf="config?.data?.type === 'TEXT'" class="notification-details">
    <div class="header">
        <img alt="alert icon" src="/assets/images/alert.png" />
        <h6 class="notification-title">{{ config?.data?.title }}</h6>
    </div>
    <div class="notification-body">
        <ng-container *ngIf="config?.data?.imageUrl">
            <img class="notification-image" alt="Notification Image" [src]="config?.data?.imageUrl" />
        </ng-container>
        <p>
            {{ config?.data?.content }}
        </p>
    </div>
    <div class="text-md-center py-4">
        <button class="btn btn-block btn-success" type="button" style="color: white; font-weight: bold; text-transform: uppercase" (click)="saveAlertAcknowledgement()">
            <i class="fa fa-times icon-right-space" aria-hidden="true"></i>
            {{ 'Dismiss' | translate }}
        </button>
    </div>
</div>

<div *ngIf="config?.data?.type !== 'TEXT'" class="image-alert">
    <img *ngIf="config?.data?.imageUrl" class="img-fluid" alt="notice-image" [src]="config?.data?.imageUrl" />
</div>
